import { SidebarModalListItem, Text } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/useOrderBundleItem'

import { OrderBundleItemModel } from '@models/types'

interface OrderBundleItemListItemProps {
  orderBundleItem: OrderBundleItemModel,
}

const OrderBundleItemListItem = (props:OrderBundleItemListItemProps) => {
  const { orderBundleItem, orderBundleItem: { title: itemTitle, options_string, quantity } } = props

  const { provider, providerPriceList, publication } = useRelations(orderBundleItem) as any

  const orderBundleItemDisplayTitle = `${quantity} x ${itemTitle} ${options_string}
  ${publication?.title ? ` - ${publication.title}` : ''}`

  return (
    <SidebarModalListItem
      // @ts-expect-error TS2322
      forceBottomBorder
      secondaryText={
        !!provider.title && !!providerPriceList.title && (
        <Text variant="ellipsis">By {provider.title} ({providerPriceList.title})</Text>
        )
      }
      title={orderBundleItemDisplayTitle}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <SidebarModalListItem.TertiaryText>
        # {orderBundleItem.id}
        {/*
       // @ts-expect-error TS2339 */}
      </SidebarModalListItem.TertiaryText>
    </SidebarModalListItem>
  )
}

export default OrderBundleItemListItem
